import { combineSlices } from "@reduxjs/toolkit";
import { sharesApi } from "@services/share";
import { coordinatesSlice, shareSlice } from "store/slices";

const rootReducer = combineSlices({
  [sharesApi.reducerPath]: sharesApi?.reducer,
  [coordinatesSlice.name]: coordinatesSlice?.reducer,
  [shareSlice.name]: shareSlice?.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
